import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
  mutation AddSubscriptionMutation($input: AddSubscriptionInput!) {
    addSubscription(input: $input) {
      subEdge {
        cursor
        node {
          id
          name
          source {
            id
            name
            image_url
            source_icon
          }
          parent {
            id
          }
        }
      }
    }
  }
`;

function sharedUpdater(store, subEdge) {
  const user_id = localStorage.getItem(GC_USER_ID);
  const userProxy = store.get(user_id);
  const connection = ConnectionHandler.getConnection(
    userProxy,
    "Tree_userSubscriptions"
  );
  if (connection) {
    ConnectionHandler.insertEdgeAfter(connection, subEdge);
  }
}

let nextClientMutationId = 0;
export default (subName, parent, source, callback) => {
  const clientMutationId = (nextClientMutationId++).toString();
  const variables = {
    input: {
      subName: subName,
      parent: parent,
      source: source,
    },
  };

  commitMutation(environment, {
    mutation,
    variables,
    updater(store) {
      const payload = store.getRootField("addSubscription");
      sharedUpdater(store, payload.getLinkedRecord("subEdge"));
    },

    optimisticUpdater(store) {
      const id = `client:addSubscription:Sub:${clientMutationId}`;
      const newSub = store.create(id, "Sub");
      newSub.setValue(id, "id");
      newSub.setValue(subName, "name");
      const parentObj = {
        id: parent,
      };
      const sourceObj = {
        id: "U291cmNlTm9kZToxNzg0",
        name: "",
        image_url: "",
        source_icon: "",
      };
      // newSub.setValue(parentObj, "parent");
      // newSub.setValue(sourceObj, "source");
      const subEdge = store.create(
        `client:addSubcription:subEdge:${clientMutationId}`,
        "subEdge"
      );
      subEdge.setLinkedRecord(newSub, "node");
      sharedUpdater(store, subEdge);
    },
    onCompleted: (response, errors) => {
      if (response.addSubcription != null) {
        callback();
      } else {
        // console.log("Unable to add Subscription!");
      }
    },
    onError: (err) => console.log(err),
  });
};
